module.exports = __webpack_public_path__ + "static/media/savingindicator.a6eaf58e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/savingindicator.gif
// module id = 1294
// module chunks = 0